var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"right","padding":"20px 60px 0 0"}},[_c('Page',{attrs:{"total":_vm.total,"current":_vm.page,"page-size":_vm.size,"show-sizer":"","show-total":"","page-size-opts":[10, 20, 30, 40,50]},on:{"on-change":_vm.page_change,"on-page-size-change":_vm.size_change}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }